import he from 'he';
import {t} from "ttag";

// export const EXCEPTION_WORDS_ON_FILTER = ['airport', 'aeroporto', 'international', 'internacional'];
export const EXCEPTION_WORDS_ON_FILTER = [];

export const decodeHtml = html => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
};

export const initializeAirports = (airports = []) => {

    if (!Array.isArray(airports)) {
        return [];
    }
    for (let aIdx in airports) {
        const a = airports[aIdx];
        for (let pIdx in a) {
            const p = a[pIdx];
            if (p && (typeof p === 'string')) {
                airports[aIdx][pIdx] = he.decode(p);
            }
        }
    }
    return airports
        ?.map(airport => { //OSP
            const inAzores = airport.azores;
            const inPortugal = airport.countryName === 'Portugal';
            const destinationsOSP = airport.destinations.filter(code => {
                const destAirport = [...airports].filter(apt => apt.code === code)[0];
                return (destAirport && ((inAzores && destAirport.countryName === 'Portugal') || (inPortugal && destAirport.azores)));
            });

            return {...airport, value: airport, label: `${airport.name}  ${airport.code}`, destinationsOSP};
        })
        ?.sort((a, b) => a.name - b.name);
};

export const replacements = (target, find, replacements) => {
    if (!target) return target;
    if (typeof find === 'string') find = [find];
    if (typeof replacements === 'string') replacements = find?.map(() => replacements);
    if (!Array.isArray(find) || !Array.isArray(replacements)) return target;
    if (!replacements.length) return target;

    for (let i = 0; i < find.length; i++) {
        const regex = new RegExp(find[i], "g");
        target = target.replace(regex, replacements.hasOwnProperty(i) ? replacements[i] : replacements[replacements.length - 1]);
    }

    return target;
};

export const filterAirports = (option, keyword = null, exceptionWords = EXCEPTION_WORDS_ON_FILTER) => {
    if (option === null || keyword === null) {
        return true;
    }

    const normalizeString = (str) => {
        if (typeof str !== "string") return "";
        return str?.toLowerCase()?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, "");
    };

    keyword = normalizeString(keyword);

    //const ew = new RegExp(`(${exceptionWords.join('|')})`);

    return (option.hasOwnProperty('value') && typeof option.value === 'string'
            && replacements(normalizeString(option.value), exceptionWords, '').includes(keyword))
        || (option.hasOwnProperty('code') && replacements(normalizeString(option.code), exceptionWords, '').startsWith(keyword))
        || (option.hasOwnProperty('code') && replacements(normalizeString(option.code), exceptionWords, '').includes(keyword))
        || (option.hasOwnProperty('name') && replacements(normalizeString(option.name), exceptionWords, '').split(' ')
            .some(w => w.startsWith(keyword)))
        || (option.hasOwnProperty('name') && replacements(normalizeString(option.name), exceptionWords, '').includes(keyword))
        || (option.hasOwnProperty('cityName') && replacements(normalizeString(option.cityName), exceptionWords, '').includes(keyword))
        || (option.hasOwnProperty('countryName') && replacements(normalizeString(option.countryName), exceptionWords, '').includes(keyword))
        || (option.hasOwnProperty('regionCode') && replacements(normalizeString(option?.regionCode), exceptionWords, '')?.includes(keyword))
        || (normalizeString(option) === keyword);
};

export const filterAirportByRegionCode = (option, regionCode = null) => {
    const keyword = regionCode?.toLowerCase();
    if (option === null || keyword === null) {
        return true;
    }
    //const ew = new RegExp(`(${exceptionWords.join('|')})`);
    return (option.hasOwnProperty('regionCode') && option?.regionCode?.toLowerCase() === keyword);
};

export const sortAirportsByRegionName = (list) => {
    return list.sort((a, b) => {
        if (a && b && a.hasOwnProperty('regionCode') && b.hasOwnProperty('regionCode')) {
            return a.regionCode.localeCompare(b.regionCode);
        }

        return a - b;
    });
}

export const sortAirports = (
    list,
    keyword = null,
    sortByProvidedKey = null,
    exceptionWords = EXCEPTION_WORDS_ON_FILTER,
    options = {
        code: ['startsWith'],
        name: ['innerStartsWith', 'includes'],
        cityName: ['includes'],
        regionName: ['includes'],
        countryName: ['includes']
    },
) => {


    if (!Array.isArray(list) || !keyword || keyword === '') return sortAirportsByRegionName(list);//options;

    // DONT RUN ABOVE CODE, IT WILL BREAK THE FUNCTIONALITY

    //const ew = new RegExp(`(${exceptionWords.join('|')})`);
    keyword = keyword.toLowerCase();

    const sortByProvidedKeyFn = (a, b) => {
        if (a && b && a.hasOwnProperty(sortByProvidedKey) && b.hasOwnProperty(sortByProvidedKey)) {
            return replacements(a[sortByProvidedKey].toLowerCase(), exceptionWords, '') - replacements(b[sortByProvidedKey].toLowerCase(), exceptionWords, '');
        }

        return a - b;
    };

    let opts = sortByProvidedKey ? [...list].sort(sortByProvidedKeyFn) : [...list];

    let resultOps = [];
    for (let prop of Object.keys(options)) {
        for (let rule of options[prop]) {
            // eslint-disable-next-line
            opts = opts.filter(o => !resultOps.includes(o));
            switch (rule) {
                case 'includes':
                    resultOps = [...resultOps, ...[...opts].filter(
                        opt => replacements(opt.hasOwnProperty(prop) && opt[prop].toLowerCase(), exceptionWords, '').includes(keyword)
                    )];
                    break;
                case 'startsWith':
                    resultOps = [...resultOps, ...[...opts].filter(
                        opt => replacements(opt.hasOwnProperty(prop) && opt[prop].toLowerCase(), exceptionWords, '').startsWith(keyword)
                    )];
                    break;
                case 'innerStartsWith':
                    resultOps = [...resultOps, ...[...opts].filter(
                        opt => replacements(opt.hasOwnProperty(prop) && opt[prop].toLowerCase(), exceptionWords, '').split(' ')
                            .some(w => w.startsWith(keyword))
                    )];
                    break;
                default:
                    break;
            }
        }
    }

    return sortAirportsByRegionName(resultOps);
};

const translateRegionCode = (regionCode) => {
    switch (regionCode) {
        case 'Azores':
            return t`Azores`;
        case 'Africa':
            return t`Africa`;
        case 'Bermuda':
            return t`Bermuda`;
        case 'Canada':
            return t`Canada`;
        case 'Estados Unidos':
            return t`United States`;
        case 'United States':
            return t`United States`;
        case 'États-Unis':
            return t`United States`;
        case 'Europe':
            return t`Europe`;
        case 'Madeira':
            return t`Madeira`;
        case 'Portugal Mainland':
            return t`Portugal Mainland`;
        default:
            return t`Unknown Region`;
    }
};

export const getOptions = (list) => {
    const removedAirports = ['BDA', 'BIO', 'MIL', 'MXP', 'OAK', 'LON', 'STN', 'LHR', 'LGW'];
    const newNamesAirports = {
        BCN: t`Barcelona - Josep Tarradellas`,
        BOS: t`Boston - Logan International`,
        JFK: t`New York - John F. Kennedy`,
        FAO: t`Faro - Gago Coutinho`,
        FRA: t`Frankfurt - Flughafen`,
        FNC: t`Funchal - Aeroporto Cristiano Ronaldo`,
        LIS: t`Lisbon - Humberto Delgado`,
        OPO: t`Porto - Francisco Sá Carneiro`,
        RAI: t`Praia - Nelson Mandela`,
        YYZ: t`Toronto - Lester B. Pearson`,
        YUL: t`Montreal - Pierre E. Trud.`
    };

    return list?.filter((a) => !removedAirports.includes(a.code))
        ?.map((item) => ({
            ...item,
            ...(newNamesAirports[item.code] ? { name: newNamesAirports[item.code] } : {}),
            regionCodeTranslation: translateRegionCode(item.regionCode),
        }));
}

export const sortByRegionCode = (list) => {
    return [...list]
        ?.map((item) => ({
            ...item,
            regionCodeTranslation: translateRegionCode(item.regionCode), // Replace regionCode with translated version
        }))
        ?.sort((a, b) => {
        if (a && b && a.hasOwnProperty('regionCode') && b.hasOwnProperty('regionCode')) {
            const translatedA = translateRegionCode(a.regionCode);
            const translatedB = translateRegionCode(b.regionCode);

            if (translatedA === 'Azores' || translatedB === 'Açores') {
                return -1;
            }
            return translatedA.localeCompare(translatedB);
        }

        return a - b;
    });
};